<template>
  <div class="home">
    <Header/>
    <Hero/>
    <About/>
    <Shop/>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Hero from '@/components/Hero.vue'
import About from '@/components/About.vue'
import Shop from '@/components/Shop.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Header,
    Hero,
    About,
    Shop,
    Footer,
  }
}
</script>

<style scoped lang="scss">
.home {
  padding-bottom: 0;
  
  &.menu-open {
    overflow: hidden;
  }

  section {
    padding-top: 70px;
    padding-bottom: 56px;
    margin-top: 32px;
  }
}

@media screen and (min-width: 768px) {
  .home {
    section {
      padding-top: 100px;
      padding-bottom: 100px;
      margin-top: 150px;
    }
  }
}
</style>